import { styled as o, Typography as k, Box as r, ButtonBase as b, useMediaQuery as B, Modal as S } from "@mui/material";
import C from "../../../../assets/images/background-image-tutorial-bg.png.js";
import u from "./StepIndicator.js";
import y from "../../generic/CloseButton.js";
import I from "../../next/Image.js";
import T from "../../../../styles/theme.js";
import { useState as v, useCallback as m, useEffect as F } from "react";
import { useTranslation as M } from "react-i18next";
import { jsx as e, jsxs as d, Fragment as $ } from "react/jsx-runtime";
const j = o(I)`
  width: 100%;
  height: auto;
  aspect-ratio: 1088/664;
`, N = o(k)`
  font-weight: 500;
  font-size: 32px;
  line-height: 36px;
  margin-bottom: 20px;
  font-weight: 500;
`, W = o(y)`
  position: absolute;
  top: -50px;
  right: 0px;
  min-width: 40px;
  color: #d8d9d9;
`, z = o(r)`
  width: 100%;
`, E = o(r)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  background-image: url(${C});
  background-size: contain;
  background-repeat: no-repeat;
  background-color: #838383;
  border: 2px solid #4d4e50;
  border-radius: 10px;
  width: 1024px;

  ${({
  theme: i
}) => i.breakpoints.down("res1024")} {
    width: 800px;
  }

  ${({
  theme: i
}) => i.breakpoints.down("res768")} {
    width: 100%;
  }
`, A = o(r)`
  border: 2px solid #f8d9a9;
  border-radius: 12px;
  width: fit-content;
  ${({
  theme: i
}) => i.breakpoints.down("res768")} {
    width: 100%;
  }
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`, D = o(r)`
  display: flex;
  flex-direction: row;
  column-gap: 40px;
  width: 100%;
`, P = o(r)`
  display: flex;
  flex-direction: column;
  width: 100%;
`, Q = o(r)`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  background: rgba(217, 217, 217, 0.2);
  border-radius: 100px;
  align-items: center;
`, q = o(b)`
  border-radius: 100px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  background: #3f3f3f;
  padding: 6px 20px;
  color: rgba(255, 255, 255, 0.5);
  width: 120px;

  &:hover {
    border-color: #d6cab8;
    background: linear-gradient(0deg, #49767d 0%, #545f63 100%);
  }
`, G = o(b)`
  border-radius: 100px;
  border: 2px solid #d6cab8;
  background: linear-gradient(0deg, #f0c056 0%, #91794c 100%);
  padding: 6px 20px;
  color: white;
  width: 120px;
`, H = o(r)`
  height: 200px;
  overflow: clip;
  box-shadow: inset 0px 0px 10px 10px #838383;
  position: relative;
  padding: 20px 20px 20px 40px;
`, J = o(r)`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px;
  background: linear-gradient(360deg, #838383ff, transparent);
`, K = o(r)`
  position: absolute;
  top: 0;
  width: 100%;
  height: 60px;
  background: linear-gradient(180deg, #838383ff, transparent);
`, tt = ({
  title: i,
  steps: n,
  isOpen: a,
  onClose: c
}) => {
  var x, g;
  const {
    t: l
  } = M(), [t, p] = v(0), h = B(T.breakpoints.down("res768")), f = m(() => {
    t !== n.length - 1 ? p((s) => s + 1) : c();
  }, [t]), w = m(() => {
    t !== 0 && p((s) => s - 1);
  }, [t]);
  return F(() => {
    a || p(0);
  }, [a]), /* @__PURE__ */ e(S, {
    open: a,
    onClose: c,
    disableEnforceFocus: !0,
    children: /* @__PURE__ */ d(A, {
      children: [/* @__PURE__ */ e(W, {
        onClick: c
      }), /* @__PURE__ */ d(E, {
        children: [/* @__PURE__ */ e(N, {
          children: i
        }), /* @__PURE__ */ d(D, {
          children: [/* @__PURE__ */ d(P, {
            children: [/* @__PURE__ */ e(z, {
              children: (x = n[t]) != null && x.imageSrc ? /* @__PURE__ */ e(j, {
                src: n[t].imageSrc
              }) : /* @__PURE__ */ e($, {
                children: (g = n[t]) == null ? void 0 : g.customContent
              })
            }), h && /* @__PURE__ */ d(H, {
              children: [/* @__PURE__ */ e(u, {
                steps: n,
                currentStepIndex: t
              }), t > 0 && /* @__PURE__ */ e(K, {}), t !== n.length && /* @__PURE__ */ e(J, {})]
            }), /* @__PURE__ */ d(Q, {
              children: [/* @__PURE__ */ e(q, {
                onClick: w,
                disabled: t === 0,
                children: l("component.tutorial.back")
              }), /* @__PURE__ */ d("span", {
                children: [t + 1, "/", n.length]
              }), /* @__PURE__ */ e(G, {
                onClick: f,
                children: t === n.length - 1 ? l("component.tutorial.finish") : l("component.tutorial.next")
              })]
            })]
          }), h ? null : /* @__PURE__ */ e(u, {
            steps: n,
            currentStepIndex: t
          })]
        })]
      })]
    })
  });
};
export {
  tt as default
};
//# sourceMappingURL=ApeironTutorialDialog.js.map
